// External Libraries
import { gql } from 'graphql-tag';

//internal modules
import {
  BUYER_FRAGMENT,
  FUNDING_OPTIONS_FRAGMENT,
  THREE_DOMAIN_SECURE_FRAGMENT,
  THREE_DS_2_CONTINGENCY_FRAGMENT,
} from '../../Form/graphql/fragments';

export const CHECKOUT_GUEST_WITH_MEMBER_BENEFITS_MUTATION = gql`
  mutation CheckoutGuestWithMemberBenefitsMutation(
    $bank: BankAccountInput
    $billingAddress: AddressInput
    $card: CardInput
    $country: CountryCodes!
    $currencyConversionType: CheckoutCurrencyConversionType
    $email: String!
    $firstName: String!
    $lastName: String!
    $phone: PhoneInput!
    $shippingAddress: AddressInput
    $supportedThreeDsExperiences: [ThreeDSPaymentExperience]
    $token: String!
  ) {
    checkoutGuestWithMemberBenefits(
      bank: $bank
      billingAddress: $billingAddress
      card: $card
      country: $country
      currencyConversionType: $currencyConversionType
      email: $email
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      shippingAddress: $shippingAddress
      token: $token
    ) {
      ...buyer

      flags {
        is3DSecureRequired
      }

      ...fundingOptions

      paymentContingencies {
        ...threeDomainSecure
        ...threeDSContingencyData
      }
    }
  }
  ${BUYER_FRAGMENT}
  ${FUNDING_OPTIONS_FRAGMENT}
  ${THREE_DOMAIN_SECURE_FRAGMENT}
  ${THREE_DS_2_CONTINGENCY_FRAGMENT}
`;
